import { forwardRef, useContext, useImperativeHandle, useRef, useState } from 'react';
import SearchOrgForm, { SearchOrgFormRef } from './search-org-form';
import { ISearchOrgInput, ISearchOrgResponse, ISearchOrgResult } from '../../../types/org';
import SearchOrgResult, { searchOrgSelectedOrg } from './search-org-result';
import { useLazyQuery } from '@apollo/client';
import { SEARCH_ORG, GET_ORG_DETAILS } from '../../../graphql/org-gql';
import { OrgReducerContext, errorSearch, messageAfterSearchResult, messageSearch } from '../../org/org-context';
import { notifySuccess, notifyWarning } from '../../../services/notification';
import SpinnerOverlay from '../../common/spinner/spinner';

type SearchOrgProps = {
  //onSearchOrgSelect:(org:IOrg|undefined)=>void
}

export type SearchOrgRef = {
  unselect: () => void;
}
const SearchOrg = forwardRef<SearchOrgRef, SearchOrgProps>((props, ref) => {

  const [searchResults, setSearchResults] = useState<ISearchOrgResult[] | undefined>();
  const [inputChanged,setInputChanged] = useState(true)
  const [getOrgDetail] = useLazyQuery(GET_ORG_DETAILS)
  const [searchOrg, { loading:searchOrgLoading, error:searchOrgError }] = useLazyQuery<ISearchOrgResponse>(SEARCH_ORG);
  const searchOrgFormRef = useRef<SearchOrgFormRef | null>(null)
  const [state, dispatch] = useContext(OrgReducerContext);
  const [isInputError, setIsInputError] = useState(false)

  const resetState = () => dispatchEvent

  const unselect =()=>{
    resetState();
  }

  useImperativeHandle(ref, () => ({
    unselect
  }));

  const onSearch = (input:ISearchOrgInput,isValid: boolean) => {
    setSearchResults([])
    dispatch({type:'reset'})
    if(!isValid){
      dispatch({type:'set-org-search-error',payload:errorSearch})
      dispatch({type:'set-org-search-message'})
      setIsInputError(true)
    }else{
      searchOrg({ variables: { input },fetchPolicy: 'no-cache',
        onCompleted: (data) => {data && notifySuccess()}
      })
      .then((response:any) => {
        response.data?.message && notifyWarning(response.data.message)
        updateSearchResults(response.data?.searchOrg.orgs)
      });
    }
  }

   const updateSearchResults = (results:ISearchOrgResult[] | undefined) => {
      setInputChanged(false)
      if(results && results.length>0){
        if(results.length>700) results = results.slice(0,700);
        setSearchResults(results);
        setTimeout(() => {
          dispatch({type:'set-org-search-message',payload:messageAfterSearchResult});
        }, 100);
      }else{
        dispatch({type:'set-org-search-org'})
      }
      
      dispatch({type:'set-org-search-error'})


   }

   const onChange = () => {
     setInputChanged(true)
   }

  const onOrgSelect = async (item: ISearchOrgResult) => {
    try {
      dispatch({type: 'reset'});
      dispatch({type: 'set-last-selected-item', payload: searchOrgSelectedOrg(item) });
      const orgDetailResponse = await getOrgDetail({ variables: {id: item.id}});
      if (orgDetailResponse.data?.org){
        //onSearchOrgSelect(orgDetailResponse.data.org)
        dispatch({
          type: 'set-org-search-org',
          payload: orgDetailResponse.data.org
        });
        dispatch({type:'set-org-search-message'})
      }
    }catch (error:any) {
      console.error('Error:', error.message)
    }
  }
  return (
    <>
      {searchOrgLoading && <SpinnerOverlay/>}
      <SearchOrgForm onChange={onChange} onSearch={onSearch} loading={searchOrgLoading} error={searchOrgError} ref={searchOrgFormRef}></SearchOrgForm>
      <br/>
      {
      //searchResults &&
        <SearchOrgResult data={searchResults} selected={state?.lastSelectedItem} onOrgSelect={onOrgSelect} inputChanged={inputChanged} isInputError={isInputError}/>
      }
    </>
  )
})


export default SearchOrg;
